import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useStyles from './IconLink.styles';

const IconLink = (props) => {
  const {
    className,
    children,
    Icon
  } = props;
  const { iconLink, icon } = useStyles(props);
  return (
    <div className={classNames(iconLink, className)}>
      <Icon className={icon} />
      {children}
    </div>
  );
};

IconLink.propTypes = {
  /** Content to show alongside the icon */
  children: PropTypes.node.isRequired,

  /** A react component to show */
  Icon: PropTypes.func.isRequired,

  /** Class name for custom usage */
  className: PropTypes.string
};

IconLink.defaultProps = {
  className: undefined
};

export default IconLink;
